import { render, staticRenderFns } from "./Backwards.vue?vue&type=template&id=309f156e&scoped=true"
import script from "./Backwards.vue?vue&type=script&lang=js"
export * from "./Backwards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309f156e",
  null
  
)

export default component.exports